// D-1081: 「保存名(prize_name)の代わりに prize_id のマスタの短縮名を出してよいか」の判定はここ 1 か所。
//   入替の行が前の景品の prize_id を持ったまま保存されることがある(KKY01-M03-B01: 保存名「ちいかわ熊本」・
//   PZ-02729 の短縮名「KTドデカパッチン」)。保存名がそのマスタの正式名(prize_masters.prize_name)と
//   一致するときだけ同じ景品とみなす。比較は前後の空白だけ落とした完全一致。表記ゆれの正規化(NFKC など)は
//   フロントでしない(D-558)。確かめられない(正式名が取れない・保存名が無い)ときは置き換えない。
//   呼び出し元: 巡回の入力欄(clawsupport/lib/prizeShortDisplay.js)・一覧(clawsupport/lib/prizeDisplayName.js)・
//   報告の景品名(services/boothAlerts.js)。services は clawsupport を import できないので shared に置く。

/**
 * @param {{shortName: unknown, savedName: unknown, masterPrizeName: unknown}} a
 * @returns {boolean}
 */
export function shortNameMatchesSavedName({ shortName, savedName, masterPrizeName }) {
  if (typeof shortName !== 'string' || !shortName.trim()) return false              // 短縮名が無い
  const saved = String(savedName ?? '')
  if (!saved) return false                                                          // 保存名が無い行は何もしない
  if (typeof masterPrizeName !== 'string' || !masterPrizeName.trim()) return false  // マスタの正式名が取れない
  return saved.trim() === masterPrizeName.trim()                                    // 保存名がこのマスタの景品か
}
